/**
 * Contact API endpoints
 */

import { fetchApi } from '../core';
import type { ContactData } from '../types';

export function submit(
  email: string,
  message: string,
  token?: string,
  courseType?: string,
  componentName: string = 'Unknown'
) {
  return fetchApi('/contact', {
    method: 'POST',
    body: JSON.stringify({
      email,
      message,
      token,
      course_type: courseType
    } as ContactData),
    requireAuth: false
  }, componentName);
}
